import { render, staticRenderFns } from "./DiagnosisTemplateManager.vue?vue&type=template&id=7224aeb8"
import script from "./DiagnosisTemplateManager.vue?vue&type=script&lang=js"
export * from "./DiagnosisTemplateManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports